import Dropdown from "@/components/global/menus/Dropdown";
import NextImage from "@/components/global/NextImage";
import ArrowIcon from "@/components/icons/ArrowIcon";
import { validateImgSrc } from "@/utils/global";
import { useRouter } from "next/router";
import { useState } from "react";

const BundleExtraProducts = ({
  product,
  selectedProducts,
  setSelectedProducts,
  t,
}) => {
  const [detailInView, setDetailInVew] = useState();
  const { locale } = useRouter();
  const [qty, setQty] = useState(1);
  function unescapeHtml(escapedHtml) {
    const htmlEntities = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'",
    };

    return escapedHtml?.replace(
      /&amp;|&lt;|&gt;|&quot;|&#39;/g,
      (match) => htmlEntities[match]
    );
  }

  const isSelected = selectedProducts
    ?.map((i) => i?.sku)
    .includes(product?.sku);

  function addItemToBundle(product, qty) {
    if (isSelected) {
      setSelectedProducts((prev) =>
        prev?.map((item) =>
          item?.sku == product?.sku ? { ...item, qty: qty } : item
        )
      );
    } else {
      setSelectedProducts((prev) => [...prev, { ...product, qty }]);
    }
  }

  function removeItemFromBundle(product) {
    setSelectedProducts((prev) => prev?.filter((p) => p?.sku !== product?.sku));
  }

  return (
    <div className="max-sm:col-span-full col-span-6 overflow-visible ">
      <div className="flex gap-4 mb-3 overflow-visible">
        <NextImage
          src={validateImgSrc(product?._media_?.image?.at(0).image)}
          className="object-contain rounded-md size-24"
          width={96}
          height={96}
          alt=""
        />
        <div className="overflow-visible  max-sm:text-xs text-lg h-fit">
          {product?.name}
          <div className="hidden items-start overflow-visible  justify-between max-sm:flex">
            <Dropdown
              options={Array(20)
                .fill(0)
                .map((e, i) => ({ label: i + 1, value: i + 1 }))}
              defaultValue={{ label: 1, value: 1 }}
              onChange={(e) => {
                setQty(e.value);
              }}
              selectedOption={{ label: qty, value: qty }}
            />
          </div>
          {/* <div className="flex flex-col gap-1 w-full min-md:hidden">
            <div className="max-sm:flex justify-between">
            {validateDiscountPrice(product) && <p className="flex items-center max-sm:text-sm gap-2">
              <span className="max-sm:hidden">{t("Price")} :</span>
              <span className="line-through text-gray-500">
                {original_price} {t("SR")}
              </span>
            </p>}
            {validateDiscountPrice(product) && <p className="flex items-center max-sm:text-sm gap-2">
                <span className="max-sm:hidden">{t("Saving")} :</span>
                <span className="font-bold text-red-600">
                  {t("Save money")} {price - original_price} {t("SR")}
                </span>
              </p>
              }
            </div>
              <p className="flex items-center max-sm:text-sm gap-2">
                <span className="max-sm:hidden">{t("Final Price")} :</span>
                <span className="font-bold max-sm:text-secondary-900">
                  {price} {t("SR")}
                </span>
              </p>

          </div> */}
          <button
            onClick={() => {
              isSelected
                ? removeItemFromBundle(product)
                : addItemToBundle(product, qty);
            }}
            className={`hidden max-sm:flex w-full justify-center items-center px-2 py-1 font-normal max-sm:px-4 max-sm:py-1 text-[11px] text-white ${
              isSelected ? "bg-red-600" : "bg-primary"
            } rounded-lg mt-2`}
          >
            {isSelected ? t("Remove item") : t("Add item")}
          </button>
        </div>
      </div>
      <div className="flex items-center max-sm:hidden gap-7">
        <div
          onClick={() =>
            detailInView?.segment != "description"
              ? setDetailInVew({
                  segment: "description",
                  data: product?.description,
                })
              : setDetailInVew(null)
          }
          className={`flex cursor-pointer items-center gap-2 max-sm:text-sm hover:font-bold ${
            detailInView?.segment === "description" && "font-bold"
          }`}
        >
          <span>{t("Description")}</span>
          <ArrowIcon
            className={`size-3 transition-all ${
              locale === "en" ? "" : "rotate-180"
            } ${detailInView?.segment === "description" && "rotate-90"}`}
          />
        </div>
        {/* <div className="flex items-center gap-2">
          <span>Additional Informations</span>
          <ArrowIcon className={`size-3`} />
        </div> */}
        <div
          onClick={() =>
            detailInView?.segment != "specifications"
              ? setDetailInVew({
                  segment: "specifications",
                  data: product?.specifications,
                })
              : setDetailInVew(null)
          }
          className={`flex cursor-pointer max-sm:text-sm items-center gap-2 hover:font-bold ${
            detailInView?.segment === "specifications" && "font-bold"
          }`}
        >
          <span>{t("Specifications")}</span>
          <ArrowIcon
            className={`size-3 transition-all ${
              locale === "en" ? "" : "rotate-180"
            } ${detailInView?.segment === "specifications" && "rotate-90"}`}
          />
        </div>
      </div>
      {detailInView && (
        <div className="bg-gray-50 p-2 mt-2">
          <div
            dangerouslySetInnerHTML={{
              __html: unescapeHtml(detailInView?.data) || "",
            }}
            className="text-zinc-400 *:text-sm transition-all"
          />
        </div>
      )}
    </div>
  );
};

export default BundleExtraProducts;
